import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { useMutation } from "@apollo/client"
import { useDispatch, useSelector } from "react-redux"
import Button from "../../components/Button/Button"
import yatzyLogo from "../../images/yatzyTrans.png"
import { LOGIN } from "../../graphql/mutations"
import { loginStart, loginSuccess, loginFailure, clearError } from "../../store/slices/authSlice"
import { setCurrentUser } from "../../store/slices/mateSlice"
import "./Login.css"

const Login = ({ onClose, onLoginSuccess, initialPassword }) => {
  const dispatch = useDispatch()
  const { loading, error } = useSelector((state) => state.auth)
  
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState(initialPassword || "")
  const [showPassword, setShowPassword] = useState(false)
  
  // Opdater password når initialPassword ændres
  useEffect(() => {
    if (initialPassword) {
      setPassword(initialPassword)
    }
  }, [initialPassword])

  const [loginMutation] = useMutation(LOGIN, {
    onCompleted: (data) => {
      // Dispatch auth success (kun token)
      dispatch(loginSuccess({
        token: data.login.token
      }))
      
      // Dispatch user data til mate slice (kommer fra backend)
      dispatch(setCurrentUser(data.login.mate))
      
      // Kald success callback hvis den findes
      if (onLoginSuccess) {
        onLoginSuccess(data.login.mate)
      }
      
      // Luk modal
      if (onClose) {
        onClose()
      }
    },
    onError: (error) => {
      dispatch(loginFailure(error.message || "Login fejlede. Tjek email og adgangskode."))
    }
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    dispatch(clearError())
    dispatch(loginStart())
    
    try {
      await loginMutation({
        variables: {
          email: email,
          password: password
        }
      })
    } catch (error) {
      dispatch(loginFailure("Login fejlede. Prøv igen."))
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  // Luk modal hvis man klikker på baggrunden
  const handleBackgroundClick = (e) => {
    if (e.target.classList.contains("login-background") && onClose) {
      onClose()
    }
  }

  const card = (
      <div className="login-container">
        <h2 className="login-title">Log In</h2>
        {error && (
          <div className="error-message" style={{ color: 'red', marginBottom: '10px', textAlign: 'center' }}>
            {error}
          </div>
        )}
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="input-container">
            <input 
              type="email" 
              placeholder="Email" 
              value={email} 
              onChange={e => setEmail(e.target.value)} 
              required 
              disabled={loading}
            />
          </div>
          
          <div className="input-container">
            <input 
              type={showPassword ? "text" : "password"} 
              placeholder="Password" 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              required 
              disabled={loading}
            />
            <button 
              type="button" 
              className="password-toggle" 
              onClick={togglePasswordVisibility}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                {showPassword ? (
                  <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                ) : (
                  <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" fill="currentColor"/>
                )}
              </svg>
            </button>
          </div>
          
          <Button 
            title={loading ? "Logger ind..." : "Log In"} 
            onClick={handleSubmit} 
            variant="contained" 
            color="secondary"
            style={{ width: '100%', marginTop: '8px' }}
            disabled={loading}
          />
        </form>
      </div>
  )

  return (
    <div className={onClose ? 'login-background' : 'login-background login-background--locked'} onClick={handleBackgroundClick}>
      {onClose ? card : (
        <div className="login-stage">
          
          <Link className="login-yatzy" to="/yatzy">
            <img src={yatzyLogo} alt="" />
            <span>
              <strong>Yatzy</strong>
            </span>
          </Link>
          {card}
        </div>
      )}
    </div>
  )
}

export default Login
